import { useNavigate } from "react-router"
import { useEffect, useState } from "react"
import { PlayerMap, PlayerPositionMap, PlayerTypeMap } from "../Utils/PlayerMaps"
import { ReactComponent as StrikeS } from '../style/images/eachhitter_icon2.svg'
import { ReactComponent as StrikeC } from '../style/images/eachhitter_icon1.svg'
import { ReactComponent as Foul } from '../style/images/eachhitter_icon3.svg'
import { ReactComponent as InPlay } from '../style/images/eachhitter_icon4.svg'
import { BubbleChart } from "./Charts/BubbleChart"
import { wrapPointData } from "../Utils/PersonChartDataProcess"
import { FieldConfig, KZoneConfig } from "./Charts/configs/person_configs"
import { SingleSelectionBox } from "./InputBox"
import { SingleTextButton } from "./SingleButtton"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCircleXmark } from "@fortawesome/free-solid-svg-icons"
import KZone from '../style/images/277415.png'
import h337 from 'heatmap.js'
import { ballColorMap } from "../Utils/ColorMap"

export const RosterFrame = ({title, players}) => {
  const navigate = useNavigate()
  const position_sort_key = {
    'P': 1, 'C': 2, 'IF': 3, 'OF': 4
  }
  const handleOnClick = (type, team, number) => {
    navigate(`/${type}/${team}/${number}`)
  }
  const RosterSingleName = ({type, team, number, name, position}) => {
    return <div className={`person_name_block p_${position}`} onClick={()=>{handleOnClick(type, team, number)}}>{name}</div>
  }
  const RosterFrameContent = ({players}) => {
    let names = []
    for (let n in players) {
      names.push(<RosterSingleName type={PlayerTypeMap[title][n]} team={title} number={n} name={players[n]} position={PlayerPositionMap[title][n]} />)
    }
    names = names.sort((a,b)=>(position_sort_key[a.props.position]-position_sort_key[b.props.position]))
    return names
  }
  const titleMap = {
    'ctbc-brothers': '中信兄弟',
    'fubon-guardians': '富邦悍將',
    'uni-7-eleven-lions': '統一7-ELEVEn獅',
    'rakuten-monkeys': '樂天桃猿',
    'wei-chuan-dragons': '味全龍'
  }
  return (
    <div className="player_list">
      <div className='page_tab_frame2'>
        <div className='tab_block tab_selected'>
          <div className='tab'>{titleMap[title]}</div>
        </div>
      </div>
      <div className='tab_content'>
        <div className='person_name_frame'>
          <RosterFrameContent players={players} />
        </div>
      </div>
    </div>
  )
}

export const PersonTable = ({sheet, tableClass="score_person_form", leftTitle=false, leftTitleMap=undefined}) => {
  const TableHeader = ({headers}) => {
    return (
      <tr>
        {headers.map((e)=>(<th>{e}</th>))}
      </tr>
    )
  }
  const Title = ({title, leftTitle, leftTitleMap}) => {
    if (leftTitle) {
      if (leftTitleMap) {
        return <td className="left_title"> {leftTitleMap[title]} <span>{title}</span></td>
      } else {
        return <td className="left_title"> {title} </td>
      }
    } else {
      return []
    }
  }
  const TableData = ({title, data}) => {
    return (
      <tr>
        <Title title={title} leftTitle={leftTitle} leftTitleMap={leftTitleMap} />
        {data.map((e)=>(<td>{e}</td>))}
      </tr>
    )
  }
  return (
    <div>
      <table className={tableClass}>
        <thead>
          <TableHeader headers={sheet.headers} />
        </thead>
        <tbody>
          {sheet.data.map((e) => {
            return <TableData title={e.title} data={e.data} />
          })}
        </tbody>
      </table>
    </div>
  )
}

export const SubTableFrame = ({ title, tables }) => {
  return (
    <>
      <div className="page_tab_frame2">
        <div className="tab_block tab_selected">
          <div className="tab">{title}</div>
        </div>
      </div>
      <div className="person_tab_content">
        {tables}
      </div>
    </>
  )
}

export const GraphFrame = ({title, classname, graph, colClass='col3', frameClass='tab_content'}) => {
  return (
    <div className={colClass}>
      <div className='page_tab_frame2'>
        <div className='tab_block tab_selected'>
          <div className='tab'>{title}</div>
        </div>
      </div>
      <div className={frameClass}>
        <div className={classname}>
          {graph}
        </div>
      </div>
    </div>
  )
}

export const WhiteBkgGraphFrame = ({title=false, classname, graph}) => {
  return (
    <div className='wbkg_col3'>
      <div className="wbkg_title">
        {title? title:[]}
      </div>
      <div className='wbkg_tab_content'>
        <div className={classname}>
          {graph}
        </div>
      </div>
    </div>
  )
}

/* Play By Play */

const pitchCallImageMap = {
  'Foul': <Foul />,
  'Strk-C': <StrikeC />,
  'Strk-S': <StrikeS />,
  'Inplay': <InPlay />,
  'In-Play': <InPlay />
}
const PlayByPitchTable = ({data}) => {
  const displayHeader = (num) => {
    let hds = []
    for (let i=0; i<num; i++) {
      hds.push(<th>{i+1}</th>)
    }
    return hds
  }
  const displayPitchCall = (data, len) => {
    let pcs = []
    for (let i=0; i<len; i++) {
      if (i >= data.length || data[i].call==='Ball') pcs.push(<td></td>)
      else pcs.push(<td>{pitchCallImageMap[data[i].call]}</td>)
    }
    return pcs
  }
  const displayPitchData = (data, len, target) => {
    let output = []
    for (let i=0; i<len; i++) {
      if (i >= data.length) output.push(<td></td>)
      else output.push(<td>{data[i][target]}</td>)
    }
    return output
  }
  const displayPitchType = (data, len) => {
    let output = []
    for (let i=0; i<len; i++) {
      if (i >= data.length || data[i].call==='Ball') output.push(<td></td>)
      else output.push(<td>{data[i].tag}</td>)
    }
    return output
  }
  const displayWhiteSpace = (data, len) => {
    let output = []
    for (let i=0; i<len; i++) {
      if (i >= data.length || data[i].call!=='Ball') output.push(<td className="white"></td>)
      else output.push(<td className="white">{data[i].tag}</td>)
    }
    return output
  }
  const tableLen = Math.max(data.length, 10)
  return (
    <table className='eachhitter_table'>
      <tbody>
        <tr>
          {displayHeader(tableLen)}
        </tr>
        <tr>
          {displayPitchCall(data, tableLen)}
        </tr>
        <tr>
          {displayPitchType(data, tableLen)}
        </tr>
        <tr>
          {displayWhiteSpace(data, tableLen)}
        </tr>
        <tr>
          {displayPitchData(data, tableLen, 'speed')}
        </tr>
      </tbody>
    </table>
  )
}
const PlayOuts = ({outs}) => {
  const outMap = [['ball_out','ball_out'], ['ball_outr', 'ball_out'], ['ball_outr', 'ball_outr']]
  return (
    <>
      <span className={outMap[outs][0]} />
      <span className={outMap[outs][1]} />
    </>
  )
}
const PlayResult = ({result}) => {
  return (
    <div className='eachhitter_res'>
      <div className='eachhitter_res_entry'>
        <p className='eachhitter_res_title'>擊球初速：</p>
        <p className='eachhitter_res_value'>{result.ev}</p>
      </div>
      <div className='eachhitter_res_entry'>
        <p className='eachhitter_res_title'>擊球仰角：</p>
        <p className='eachhitter_res_value'>{result.la}</p>
      </div> 
      <div className='eachhitter_res_entry'>
        <p className='eachhitter_res_title'>打席結果：</p>
        <p className='eachhitter_res_value'>{result.result}</p>
      </div>         
    </div>
  )
}
export const SinglePlayFrame = ({playData}) => {
  return (
    <div className='eachhitter_frame'>
      <div className='eachhitter_block'>
        <div className='eachhitter_pitcher'>
          <div className='eachhitter_pitcher_title'>投手：{`${playData.pitcher} ${playData.pitcherSide}`}</div>
          <BubbleChart data={wrapPointData(playData.zoneGraphData, 0.5)} config={KZoneConfig} />
        </div>
      </div>
      <div className='eachhitter_block2'>
        <div className='eachhitter_info'>
          <span className='date'>{playData.date}</span>
          <span className='out'>出局數：<PlayOuts outs={playData.outs} /></span>
        </div>
        <div className='eachhitter_pbp_res'>
          <PlayByPitchTable data={playData.pbp} />
          <PlayResult result={playData.playResult} />
        </div>
      </div>
      <div className='eachhitter_block'>
        <div className='eachhitter_hitter'>
          <div className='eachhitter_hitter_title'>打者：{`${playData.batter} ${playData.batterSide}`}</div>
          <BubbleChart data={wrapPointData(playData.fieldGraphData)} config={FieldConfig} />
        </div>
      </div>
    </div>
  )
}

export const PlayByPlayFrame = ({data, type='pitcher'}) => {
  const [year, setYear] = useState(Object.keys(data).at(-1))
  const [gno, setGno] = useState(Object.keys(data[Object.keys(data).at(-1)]).at(0))
  const [inn, setInn] = useState(Object.keys(data[Object.keys(data).at(-1)][Object.keys(data[Object.keys(data).at(-1)]).at(0)]).at(0))
  const [pbpTags, setPBPTags] = useState(Object.keys(data[Object.keys(data).at(-1)][Object.keys(data[Object.keys(data).at(-1)]).at(0)]))
  const [pbpdata, setPBPData] = useState(data[Object.keys(data).at(-1)][Object.keys(data[Object.keys(data).at(-1)]).at(0)])
  useEffect(() => {
    setGno(Object.keys(data[year])[0])
  }, [year])
  const displayPlays = (data) => {
    return data.map((e) => {
      return <SinglePlayFrame playData={e} />
    })
  }
  const displayTabs = (inns) => {
    return inns.map((e) => (
        <div className={e===inn? 'tab_block tab_selected':'tab_block'} onClick={(evt)=>{setInn(e)}}>
          <div className='tab inn_tab'>{e}</div>
        </div>
    ))
  }
  const generateDateOptions = (obj) => {
    let keys = []
    for (let g in obj) {
      let fkey = Object.keys(obj[g])[0]
      let d = obj[g][fkey][0].date
      let cutPos = d.indexOf('-')
      d = d.slice(cutPos+1, 12)
      keys.push(d + '-G' + g)
    }
    return keys
  }
  const getKeyFromDateOptions = (key) => {
    let cutPos = key.indexOf('G')
    if (cutPos === -1) return key
    return key.slice(cutPos+1, 15)
  }
  const concatInningPlays = (obj) => {
    let output = []
    for (let inn in obj) {
      output = output.concat(obj[inn])
    }
    return output
  }
  const handleSetGame = () => {
    const newTags = Object.keys(data[year][getKeyFromDateOptions(gno)])
    setPBPTags(newTags)
    setInn(newTags[0])
    setPBPData(data[year][getKeyFromDateOptions(gno)])
  }
  return (
    <>
      <div className="play_by_play_selects">
        <span>年份</span>
        <SingleSelectionBox options={Object.keys(data)} value={year} handleOnChange={(e)=>{setYear(e.target.value)}} />
        <span>場次</span>
        <SingleSelectionBox options={generateDateOptions(data[year])} value={gno} handleOnChange={(e)=>{setGno(e.target.value)}} />
        <SingleTextButton usage={'pbp_submit'} text={"Search"} onClick={handleSetGame} />
      </div>
      <br/>
      <div className='page_tab_frame2'>
        {type==='pitcher'? displayTabs(pbpTags):[]}
      </div>
      <div className='tab_content tab_content_gray'>
        {data===undefined || data[year]===undefined? 'NO RESULT':(type==='pitcher'? displayPlays(pbpdata[inn]):displayPlays(concatInningPlays(pbpdata)))}
      </div>
    </>
  )
}

export const EmptyFrame = () => {
  return (
    <div className="frame_empty">
      <FontAwesomeIcon icon={faCircleXmark} />
      <p className="empty_msg">Sorry, no data avaiable.</p>
    </div>
  )
}

export const wrapBallCountTitleWithLight = (title, hidecount=false) => {
  let s = parseInt(title[0]), b = parseInt(title[2])
  let strikes = []
  let balls = []
  for (let i=1; i<=2; i++) {
    if (i <= s) {
      strikes.push(<div className="solid-strike" />)
    } else {
      strikes.push(<div className="hollow-strike" />)
    }
  }
  for (let i=1; i<=3; i++) {
    if (i <= b) {
      balls.push(<div className="solid-ball" />)
    } else {
      balls.push(<div className="hollow-ball" />)
    }
  }
  return (
    <div className="bc-title">
      {balls}
      {strikes}
      {hidecount? []:<div className="bc-text">{title}</div>}
    </div>
  )
}

export const PersonalProfileFrame = ({team, number}) => {
  return (
    <div className="col3_p">
      <div className="page_tab_frame2">
        <div className="tab_block tab_selected">
          <div className="tab">個人資料</div>
        </div>
        <div className="tab_content3">
          <div className="player_img"><img src="https://www.si.com/.image/t_share/MTc5ODA5MDM5OTIzMDMwMDA1/fenway-brian-fluharty-copy.jpg" /></div>
          <div className="player_headimg"><img src="https://cdn-icons-png.flaticon.com/512/177/177699.png" /></div>
          <div className="player_name">{PlayerMap[team][number]}</div>
          <div className="player_info">
            P | B/T: L/R | 6' 4" 180LBS | Age: 18
            <div className="player_sep"></div>
            Draft: 2022 | Rd: 1, #1, New York Mets | Colombia
          </div>
          <div className="player_app">
            <div className="player_title">Player Apps</div>
            Pitch Highlighter | Visual Pitch Report | Player Similarity | 3d Pitches | Pitch Mix | Plinko | Texture Map | Shifts | Swing Take Profile |
          </div>
        </div>
      </div>
    </div>
  )
}

const PitchNameMap = {
  FB: '4-Seam Fastball',
  CB: 'Curve',
  SL: 'Slider',
  CH: 'Changeup',
  SC: 'Slow Curve',
  SP: 'Splitter',
  KN: 'Knuckle',
  CT: 'Cutter',
  SFF: 'Split-Finger Fastball',
  FT: 'Sinker',
  OT: 'Others'
}

export const PitchHeatMap = ({title, data}) => {
  const [instance, setInstance] = useState(null)
  useEffect(() => {
    if (instance !== null) {
      instance.setData({min:0, max:1, data: data.data})
    }
    let its = h337.create({
      container: document.getElementById("hb-"+title),
      gradient: {
        ".20": "#ffffff",
        ".25": "#6889c2",
        ".40": "#9bb0d6",
        ".55": "#cdd8eb",
        ".70": "#ffffff",
        ".725": "#f5c8ca",
        ".80": "#ec9094",
        ".875": "#e2585e",
        ".925": "#d82129"
      },
      maxOpacity: 0.9,
      minOpacity: 0.1,
      blur: 1
    });
    its.setData(data.data? {min:0, max:0.9, data: data.data} : {min:0, max: 1, data: [{x: 0, y: 0, value: 0, radius: 0.5}]});
    // console.log(title, its.getData())
    setInstance(its)
  }, [data])
  return (
    <div className="col3_htmp">
      <div className="tab_content">
        <div className={"htmp-title"} style={{color: `${ballColorMap[title]}`}}>{PitchNameMap[title]}</div>
        <div className="htmp-usage">{data.count} pitches ({data.usage}%)</div>
        <hr />
        <div className="heatmap-body" id={'hb-'+title}>
          <img src={KZone} alt='kzone' />
        </div>
      </div>
    </div>
  )
}

export const BattedHeatMap = ({title, data}) => {
  const [instance, setInstance] = useState(null)
  useEffect(() => {
    if (instance !== null) {
      instance.setData({min:0, max:1, data: data.data})
    }
    let its = h337.create({
      container: document.getElementById("hb-"+title),
      gradient: { 
        ".25": "#6889c2",
        ".3": "#9bb0d6",
        ".4": "#cdd8eb",
        ".5": "#ffffff",
        ".6": "#f5c8ca",
        ".7": "#ec9094",
        ".8": "#e2585e",
        ".9": "#d82129"
      },
      maxOpacity: 0.9,
      minOpacity: 0.1,
      blur: 1
    });
    its.setData(data.data? {min:0, max:4.8, data: data.data} : {min:0, max: 6, data: [{x: 0, y: 0, value: 0, radius: 0.5}]});
    // console.log(title, its.getData())
    setInstance(its)
  }, [data])
  return (
    <div className="col3_htmp">
      <div className="tab_content">
        <div className={"htmp-title"}>{title[0]}B{title[2]}S</div>
        <div className="htmp-usage"> </div>
        <hr />
        <div className="heatmap-body" id={'hb-'+title}>
          <img src={KZone} alt='kzone' />
        </div>
      </div>
    </div>
  )
}

export const AdditionalHeader = ({name, titles, titleMap, current, changePage}) => {
  return (
    <div className="addition-header">
      <div className="ahdr-name">{name}</div>
      {titles.map((e) => (
        <div id={e} className={e===current? 'ahdr-page ahdr-selected':'ahdr-page'} onClick={(evt) => {changePage(e)}}>
          <span>{titleMap[e]}</span>
        </div>
      ))}
    </div>
  )
}

export const FullLengthGraphFrame = ({graph, height=null}) => {
  return (
    <div className="full-length-graph-frame" style={height? {height: `${height}`}:{}}>
      {graph}
    </div>
  )
}